<template>
  <div class="collapse" id="collapseExample">
    <v-card class="pa-3">
      <button
        class="btn btn-danger pull-right white--text"
        type="button"
        data-toggle="collapse"
        data-target="#collapseExample"
        aria-expanded="false"
        aria-controls="collapseExample"
      >
        Cerrar este formulario
      </button>
      <p class="text-primary"><b>I. Datos Personales</b></p>
      <div class="card bg-info card-body" style="margin-top: 0">
        <p>
          <b>IMPORTANTE:</b> Utilice este formulario solamente si no encontró al estudiante en el cuadro de busqueda. (Sino en
          vano va a llenar este formulario) El estudiante se crea o registra una sola ves, si el estudiante ya fue
          registrado en esta sede o en otra sede, no es necesario volverlo a inscribir, se puede reutilizar los mismos
          datos personales del estudiante para futuras inscripciones.
        </p>
        <hr />

        <form @submit.prevent="validarCamposEst" style="margin-top: 0" novalidate>
          <div class="row">
            <div class="col-sm-3">
              <Paises :model="newEstudiante" :class="{ 'has-error': validation.hasError('newEstudiante.idpais') }" />
              <small> <span class="red--text">*</span> Nacionalidad del participante</small>
              <div class="error" v-if="validation.hasError('newEstudiante.idpais')">
                {{ validation.firstError('newEstudiante.idpais') }}
              </div>
            </div>
            <div class="col-sm-3" v-show="onlyread_ci" :class="{ 'has-error': validation.hasError('newEstudiante.iddepartamento') }">
              <Departamentos ref="refDepartamentosExt" :panama="true" :model="newProvincia" :showext="false" />
              <small> <span class="red--text">*</span> Provincia </small>
            </div>
            <div class="col-sm-3" v-show="onlyread_ci" :class="{ 'has-error': validation.hasError('newEstudiante.iddepartamento') }">
              <CiudadesExt ref="refCiudadesExt" :panama="true" :model="newCiudadExt"  />
            </div>
          </div>
          
          <div class="row">
            <div class="col-sm-3" :class="{ 'has-error': validation.hasError('newEstudiante.num_doc') }">
              <div class="input-group input-group-sm">
                <AEstudianteByDoc :model="newEstudiante" :inscripcion="inscripcion" :idpais="newEstudiante.idpais" />
                <span class="input-group-addon" id="sizing-addon3"> {{ extension }} </span>
              </div>
              <small> <span class="text-danger">*</span> Documento sin extension</small>
              <div class="error" v-if="validation.hasError('newEstudiante.num_doc')">
                {{ validation.firstError('newEstudiante.num_doc') }}
              </div>
            </div>
            <div class="col-sm-3" v-show="!onlyread_ci" :class="{ 'has-error': validation.hasError('newEstudiante.iddepartamento') }">
              <Departamentos ref="refDepartamentos" :panama="false" :model="newEstudiante" showext="true" />
              <small> Extension </small>
              <div class="error" v-if="validation.hasError('newEstudiante.iddepartamento')">
                {{ validation.firstError('newEstudiante.iddepartamento') }}
              </div>
            </div>
            <div class="col-sm-6" :class="{ 'has-error': validation.hasError('newEstudiante.domicilio') }">
              <input v-model.trim="newEstudiante.domicilio" type="text" class="form-control" placeholder="Direccion" />
              <small> <span class="red--text">*</span> Direccion/Domicilio</small>
              <div class="error" v-if="validation.hasError('newEstudiante.domicilio')">
                {{ validation.firstError('newEstudiante.domicilio') }}
              </div>
            </div> 
          </div>
          <p></p>
          <br />

          <div class="row">
            <div class="col-sm-3" :class="{ 'has-error': validation.hasError('newEstudiante.nombres') }">
              <input v-model.trim="newEstudiante.nombres" type="text" class="form-control" placeholder="Nombres" />
              <small> <span class="text-danger">*</span> Nombres</small>
              <div class="error" v-if="validation.hasError('newEstudiante.nombres')">
                {{ validation.firstError('newEstudiante.nombres') }}
              </div>
            </div>
            <div class="col-sm-3" :class="{ 'has-error': validation.hasError('newEstudiante.seg_apellido') }">
              <input
                v-model.trim="newEstudiante.pri_apellido"
                type="text"
                class="form-control"
                placeholder="Apellido"
              />
              <small>  Apellido 1</small>
              <div class="error" v-if="validation.hasError('newEstudiante.seg_apellido')">
                {{ validation.firstError('newEstudiante.seg_apellido') }}
              </div>
            </div>
            <div class="col-sm-3" :class="{ 'has-error': validation.hasError('newEstudiante.seg_apellido') }">
              <input
                v-model.trim="newEstudiante.seg_apellido"
                type="text"
                class="form-control"
                placeholder="Apellido"
              />
              <small>Apellido 2</small>
              <div class="error" v-if="validation.hasError('newEstudiante.seg_apellido')">
                {{ validation.firstError('newEstudiante.seg_apellido') }}
              </div>
            </div>
            <div class="col-sm-3" v-show="!onlyread_ci">
              <Ciudades ref="refCiudades" :model="newEstudiante" />
              <small>Ciudad de residencia.</small>
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-sm-2" :class="{ 'has-error': validation.hasError('newEstudiante.fecha_nac') }">
              <Fecha :model="newEstudiante" :valueto="'fecha_nac'" />
              <small> <span class="text-danger">*</span> Fecha de Nacimiento</small>
              <div class="error" v-if="validation.hasError('newEstudiante.fecha_nac')">
                {{ validation.firstError('newEstudiante.fecha_nac') }}
              </div>
            </div>
            <div class="col-sm-2" :class="{ 'has-error': validation.hasError('newEstudiante.sexo') }">
              <div class="btn-group">
                <label class="btn btn-sm btn-link">
                  <input type="radio" v-model="newEstudiante.sexo" name="sexo" value="F" /> F
                </label>
                <label class="btn btn-sm btn-link">
                  <input type="radio" v-model="newEstudiante.sexo" name="sexo" value="M" /> M
                </label>
              </div>
              <small
                ><br />
                <span class="text-danger">*</span> Sexo</small
              >
              <div class="error text-danger" v-if="validation.hasError('newEstudiante.sexo')">
                {{ validation.firstError('newEstudiante.sexo') }}
              </div>
            </div>
            <div class="col-sm-2" :class="{ 'has-error': validation.hasError('newEstudiante.est_civil') }">
              <div class="btn-group">
                <label class="btn btn-sm btn-link">
                  <input type="radio" v-model="newEstudiante.est_civil" name="ecivil" value="S" /> S
                </label>
                <label class="btn btn-sm btn-link">
                  <input type="radio" v-model="newEstudiante.est_civil" name="ecivil" value="C" /> C
                </label>
              </div>
              <small
                ><br />
                Estado civil</small
              >
              <div class="error" v-if="validation.hasError('newEstudiante.est_civil')">
                {{ validation.firstError('newEstudiante.est_civil') }}
              </div>
            </div>
            <div class="col-sm-6" :class="{ 'has-error': validation.hasError('newEstudiante.email') }">
              <input
                v-model.trim="newEstudiante.email"
                type="text"
                class="form-control"
                placeholder="Correo electronico"
              />
              <small> <span class="text-danger">*</span> Correo electronico</small>
              <div class="error" v-if="validation.hasError('newEstudiante.email')">
                {{ validation.firstError('newEstudiante.email') }}
              </div>
            </div>
          </div>
          <br />
          <br />
          <div class="row">
            <div class="col-sm-3" :class="{ 'has-error': validation.hasError('newEstudiante.telefono1') }">
              <vue-tel-input ref="refTel" v-model="telefonows"></vue-tel-input>
              <small class="text-primary">
                <a :href="`${apiwhatsapp}` + newEstudiante.telefono1" target="_blank">
                  whatsapp: {{ newEstudiante.telefono1 }}
                </a>
              </small>
              <!-- <input v-model.trim="newEstudiante.telefono1" type="text" class="form-control" placeholder="Telefono movil">
                                    <small> <span class="text-danger">*</span> Telefono movil</small> -->
              <div class="error" v-if="validation.hasError('newEstudiante.telefono1')">
                {{ validation.firstError('newEstudiante.telefono1') }}
              </div>
            </div>
            <div class="col-sm-3" :class="{ 'has-error': validation.hasError('newEstudiante.telefono2') }">
              <input
                v-model.trim="newEstudiante.telefono2"
                type="text"
                class="form-control"
                placeholder="Telefono Fijo"
              />
              <small>Telefono Fijo</small>
              <div class="error" v-if="validation.hasError('newEstudiante.telefono2')">
                {{ validation.firstError('newEstudiante.telefono2') }}
              </div>
            </div>
            <div class="col-sm-3" :class="{ 'has-error': validation.hasError('newEstudiante.datos_laborales') }">
              <input
                v-model.trim="newEstudiante.datos_laborales"
                type="text"
                class="form-control"
                placeholder="Persona de contacto"
              />
              <small>Persona de contacto</small>
              <div class="error" v-if="validation.hasError('newEstudiante.datos_laborales')">
                {{ validation.firstError('newEstudiante.datos_laborales') }}
              </div>
            </div>
            <div class="col-sm-3" :class="{ 'has-error': validation.hasError('newEstudiante.contacto') }">
              <input
                v-model.trim="newEstudiante.contacto"
                type="text"
                class="form-control"
                placeholder="Telefono del contacto"
              />
              <small>Telefono del contacto</small>
              <div class="error" v-if="validation.hasError('newEstudiante.contacto')">
                {{ validation.firstError('newEstudiante.contacto') }}
              </div>
            </div>
          </div>
          <br />

          <p class="text-primary"><b>II. Datos Academicos</b></p>
          <div class="xcard">
            <div class="row">
              <div class="col-sm-3">
                <Grados :model="newEstudiante" />
                <small>Grado Academico</small>
              </div>
              <div class="col-sm-3" :class="{ 'has-error': validation.hasError('newEstudiante.profesiones') }">
                <Profesiones :model="newEstudiante" :multiple="true" :valueto="'profesiones'" />
                <small> <span class="text-danger">*</span> Profesion</small>
                <div class="error" v-if="validation.hasError('newEstudiante.profesiones')">
                  {{ validation.firstError('newEstudiante.profesiones') }}
                </div>
              </div>
              <div class="col-sm-6">
                <Universidades :model="newEstudiante" />
                <small>Universidad de egreso</small>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-3" :class="{ 'has-error': validation.hasError('newEstudiante.usuario_moodle') }">
                <input
                  v-model.trim="newEstudiante.usuario_moodle"
                  type="text"
                  class="form-control"
                  placeholder="Login de moodle"
                />
                <small> <span class="text-danger">* </span> Usuario Moodle</small>
                <div class="error" v-if="validation.hasError('newEstudiante.usuario_moodle')">
                  {{ validation.firstError('newEstudiante.usuario_moodle') }}
                </div>
              </div>
              <div class="col-sm-3" :class="{ 'has-error': validation.hasError('newEstudiante.clave_moodle') }">
                <input
                  v-model.trim="newEstudiante.clave_moodle"
                  type="text"
                  class="form-control"
                  placeholder="Clave de moodle"
                />
                <small> <span class="text-danger">* </span> Clave Moodle</small>
                <div class="error" v-if="validation.hasError('newEstudiante.clave_moodle')">
                  {{ validation.firstError('newEstudiante.clave_moodle') }}
                </div>
              </div>
            </div>
          </div>
          <br />
          <p class="text-primary"><b>III. Datos Laborales</b></p>
          <div class="xcard">
            <div class="row">
              <div class="col-sm-6">
                <p>
                  <small>Si no encuentra la empresa, seleccione <b>'INDEPENDIENTE'</b></small>
                </p>
                <Empresas :model="newEstudiante" />
                <small>Empresa</small>
              </div>
              <div class="col-sm-6" :class="{ 'has-error': validation.hasError('newEstudiante.cargo') }">
                <p><small>Escriba el cargo del estudiante en la empresa</small></p>
                <input v-model.trim="newEstudiante.cargo" type="text" class="form-control" placeholder="Cargo" />
                <small>Cargo</small>
                <div class="error" v-if="validation.hasError('newEstudiante.cargo')">
                  {{ validation.firstError('newEstudiante.cargo') }}
                </div>
              </div>
            </div>
          </div>
          <Alertas ref="alertar" />
          <p class="text-center">{{ msg }}</p>
          <button
            class="btn btn-danger pull-right white--text"
            type="button"
            data-toggle="collapse"
            data-target="#collapseExample"
            aria-expanded="false"
            aria-controls="collapseExample"
          >
            Cerrar este formulario
          </button>
          <button class="btn btn-azul" @click="validarCamposEst()">Registrar Estudiante</button>
        </form>
      </div>
    </v-card>
  </div>
</template>

<script>
  import Ciudades from '@/components/ACiudades.vue';
  import CiudadesExt from '@/components/ACiudadesExt.vue';
  import Departamentos from '@/components/ADepartamentos.vue';
  import Universidades from '@/components/AUniversidades.vue';
  import Profesiones from '@/components/AProfesiones.vue';
  import AEstudianteByDoc from '@/components/AEstudianteByDoc.vue';
  import Paises from '@/components/APaises.vue'; 
  import Grados from '@/components/AGrados.vue';
  import Empresas from '@/components/AEmpresas.vue';
  import Alertas from '@/components/AAlertas.vue';
  import Fecha from '@/components/AFecha.vue';
  import { Validator } from 'simple-vue-validator';
  import gql from 'graphql-tag';
  import { parseJsonError, getCleanedString } from '@/components/Utils.js';

  export default {
    props: {
      inscripcion: { type: Object, required: true },
    },
    data() {
      return {
        activo: true,
        preinscribir: true,
        api_whassap: process.env.VUE_APP_API_WHATSAPP,
        apiwhatsapp: process.env.VUE_APP_API_WHATSAPP,
        msg: '',
        extension: '',
        
        programa: {},
        notification: {
          nombre: 'Diegotes',
          mail: 'eclipseconsol@mail.com',
          url: process.env.VUE_APP_URL_NOTIFIER + 'create-student-notification', // TODO: REVISAR LA url de esta funcion create-student-notification
        },
        onlyread_ci: false,
        telefonows: '',
        newProvincia:{
          iddepartamento: null,
        },
        newCiudadExt:{
          idciudadext: null,
        }, 
        newEstudiante: {
          num_doc: null,
          nombres: null,
          pri_apellido: null,
          email: null,
          sexo: null,
          tipo: 'E',
          diestro: true,
          profesiones: [],

          idempresa: null,
          grados: [],
          idinstitucion: null,
          iddepartamento: null,
          idpais: null,
          idciudad: null,
          contacto: null,
          domicilio: null,
          datos_laborales: null,
          est_civil: null,
          fecha_nac: null,
          telefono2: null,
          telefono1: null,
          seg_apellido: null,
          usuario_moodle: null,
          clave_moodle: null,

          //este no esta, debe ser concatenado a datos laborales
          cargo: null,
        },
        cuotas: [],
      };
    },
    components: { Ciudades, Departamentos, Universidades, Profesiones, Grados, Empresas, Alertas, Fecha, AEstudianteByDoc, Paises, CiudadesExt },
    validators: {
      /*'newEstudiante.num_doc'(value) {
        return Validator.value(value)
          .required()
          .minLength(6)
          .regex('^[1-9]\\d{5,14}(\\-([A-Z0-9]{1,2}))?$');
      },*/
      'newEstudiante.nombres'(value) {
        return Validator.value(value)
          .required()
          .minLength(3)
          .regex('^[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+(\\s[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+)*$');
      },
      /* 'newEstudiante.pri_apellido'(value) {
        return Validator.value(value)
          .required()
          .minLength(3)
          .regex('^[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+(\\s[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+)*$');
      }, */
      'newEstudiante.pri_apellido'(value) {
        return Validator.value(value)
          .minLength(0)
          .regex('^[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+(\\s[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+)*$');
      },
      'newEstudiante.email'(value) { 
        const v = Validator.value(value).email().required();
        const ms = Object.keys(v._messages).length; 
        if(ms==0){
          return Validator.value(value).regex(/^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/);
        }
        return v;
      },
      'newEstudiante.sexo'(value) {
        return Validator.value(value).required();
      },
      'newEstudiante.fecha_nac'(value) {
        return Validator.value(value).required();
      }, 
      'newEstudiante.profesiones'(value) {
        return Validator.value(value).required();
      },
      'newEstudiante.idpais'(value) {
        return Validator.value(value).required();
      },
      'newEstudiante.usuario_moodle'(value) {
        return Validator.value(value)
          .minLength(4)
          .required();
      },
      'newEstudiante.clave_moodle'(value) {
        return Validator.value(value)
          .minLength(4)
          .required();
      },

      'newEstudiante.telefono1'(value) {
        return Validator.value(value)
          .required()
          .minLength(5)
          .maxLength(20)
          .digit();
      },
      'newEstudiante.telefono2'(value) {
        return Validator.value(value).digit();
      },
      'newEstudiante.seg_apellido'(value) {
        return Validator.value(value)
          .minLength(0)
          .regex('^[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+(\\s[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+)*$');
      },
      'newEstudiante.datos_laborales'(value) {
        return Validator.value(value)
          .minLength(0)
          .regex('^[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+(\\s[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+)*$');
      },
      'newEstudiante.cargo'(value) {
        return Validator.value(value)
          .minLength(0)
          .regex('^[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+(\\s[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+)*$');
      },
      'newEstudiante.contacto'(value) {
        return Validator.value(value).digit();
      },
      'newEstudiante.domicilio'(value) {
        return Validator.value(value)
          .required()
          .minLength(0)
          .regex('^([a-zñáéíóúA-ZÁÉÍÓÚÑ 0-9])([a-zñáéíóúA-ZÁÉÍÓÚÑ 0-9 % # ° / : , \' " “ ” - . _ & ()]+)$');
      },
    },
    watch: {
      newEstudiante: {
        deep: true,
        handler(a) {
          if (a == null) return;
          this.$refs.alertar.reset();
          this.msg = '';
          this.preinscribir = true;
          window.sessionStorage.setItem('xnewEstudiante', JSON.stringify(this.newEstudiante));
        },
      },

      'newEstudiante.nombres': function() {
        this.crearLogin();
      },
      'newEstudiante.pri_apellido': function() {
        this.crearLogin();
      },
      'newEstudiante.seg_apellido': function() {
        this.crearLogin();
      },
      'newEstudiante.num_doc': function() {
        this.crearClave();
      },
      'newEstudiante.iddepartamento': function() {
        this.crearClave();
        if (this.newEstudiante.iddepartamento) this.extension = this.newEstudiante.iddepartamento.extension;
        else this.extension = '';
      },
      'newEstudiante.idpais': function(){
        this.onlyread_ci = false;
         
        if(this.newEstudiante.idpais && this.newEstudiante.idpais.id != 1){ 
          if(this.newEstudiante.idpais.id == 141 ) this.$refs.refTel.activeCountryCode = 'PA';
          this.onlyread_ci = true;
          this.$refs.refDepartamentos.setID(10);
          this.$refs.refDepartamentosExt.getDatos(this.newEstudiante.idpais.id);
        }else{
          this.$refs.refDepartamentos.setID(-1);
          this.newProvincia.iddepartamento = null;
          this.$refs.refCiudades.setNull();
          this.$refs.refTel.activeCountryCode = 'BO';
        }
      },
      'newProvincia.iddepartamento': function(){
        if(this.newProvincia.iddepartamento){
          this.$refs.refCiudadesExt.getDatos(this.newProvincia.iddepartamento.id);
        }else{
          this.$refs.refCiudadesExt.getDatos(null);
        }
      },
      telefonows: function() {
        let limpio = this.telefonows.replace('+', '');
        limpio = limpio.replace(/ /g, '');
        this.newEstudiante.telefono1 = limpio;
      },
    },
    methods: {
      main() {},
      crearLogin() {
        var a = this.newEstudiante.nombres;
        var ap = this.newEstudiante.pri_apellido;
        var am = this.newEstudiante.seg_apellido;
        var inicial = '';
        var aa = '';
        var mm = '';
        if (a && a.length > 0) {
          inicial = a.substring(0, 1);
        }
        if (ap && ap.length > 0) {
          aa = ap.replace(/\s+/g, '');
        }
        if (am && am.length > 0) {
          mm = am.replace(/\s+/g, '');
        }
        var logi = inicial + aa + mm;
        /*this.newEstudiante.usuario_moodle = inicial + aa+ mm;
            this.newEstudiante.usuario_moodle = this.newEstudiante.usuario_moodle.toLowerCase()*/
        logi = getCleanedString(logi);
        //this.newEstudiante.usuario_moodle = this.newEstudiante.usuario_moodle.toLowerCase()
        this.newEstudiante.usuario_moodle = logi;
      },
      crearClave() {
        var car = this.newEstudiante.num_doc;
        var ci = '';
        var dep = this.newEstudiante.iddepartamento;
        if (car && car.length > 0) ci = this.newEstudiante.num_doc;
        if (dep) ci = ci + this.newEstudiante.iddepartamento.extension;
        this.newEstudiante.clave_moodle = ci;
      },

      validarCamposEst() {
        if (!this.activo) return;
        this.activo = false;

        if( this.newEstudiante.fecha_nac ){
          let d = new Date(this.newEstudiante.fecha_nac);
          let f = new Date().getFullYear();
          if(d.getFullYear() <= 1900 || d.getFullYear() > f){
            this.$refs.alertar.invalido();
            this.activo = true;
            this.$root.$notify.show(`fecha de nacimiento no valida`, {color:'red',x: 'right',});
            return;
          }
        }
        
        if( this.newEstudiante.domicilio && this.newEstudiante.domicilio.length < 5 ){
          this.$root.$notify.show(`falta el domicilio, (muy corto)`, {color:'red',x: 'right',});
          this.activo = true;
          return;
        }

        this.$validate().then((success) => {
          var obj = window.Object.assign({}, this.newEstudiante);
          if (!obj.usuario_moodle) {
            this.$refs.alertar.invalido('Debe Ingresar el usuario moodle.');
            this.activo = true;
            return;
          }

          if(this.newEstudiante.idpais.id == 141){
            if(!this.newProvincia.iddepartamento){
              this.$refs.alertar.invalido('Debe seleccionar la provincia.');
              this.activo = true;
              return;
            }
            if(!this.newCiudadExt.idciudadext){
              this.$refs.alertar.invalido('Debe seleccionar o escribir el nombre de la ciudad.');
              this.activo = true;
              return;
            }
            if(typeof(this.newCiudadExt.idciudadext) == 'string'){
              obj.nombre_ciudad = this.newCiudadExt.idciudadext;
            }
            obj.iddepartamento_provincia = this.newProvincia.iddepartamento.id; 
          }

          //window.console.log('NUEVO REGISTRO STDENT: ', JSON.stringify(obj, 4, null));

          if (success) {
            var ids = [];
            obj.profesiones.forEach(function(e) {
              ids.push(e.id);
            });
            delete obj.profesiones;
            obj.profesiones = ids;
            this.simpleValues(obj);
            this.$store.state.obj = obj;
            this.$store.dispatch('quitarNulos');
            if (obj.idpais) obj.idpais = obj.idpais.id;

            //window.console.log('NEW EST::',window.stringifyObject(obj));
            this.$refs.alertar.cargando();
            this.enviarDAtos(obj);
          } else {
            window.console.log(window.stringifyObject(obj));
            this.$refs.alertar.invalido();
            this.activo = true;
          }
        });
      },
      simpleValues(obj) {
        if (obj.idempresa != null) obj.idempresa = obj.idempresa.id;
        if (obj.iddepartamento != null) obj.iddepartamento = obj.iddepartamento.id;
        if (obj.idciudad != null) obj.idciudad = obj.idciudad.id;
        if (obj.iduniversidad != null) obj.idinstitucion = obj.iduniversidad.id;
        if (obj.datos_laborales != null) obj.datos_laborales = obj.cargo + ', ' + obj.datos_laborales;
        if (obj.idgrado != null) {
          obj.grados = [];
          obj.grados.push({ idgrado: obj.idgrado.id, titulo: obj.idgrado.nombre });
        } else obj.datos_laborales = obj.cargo;
        delete obj.iduniversidad;
        delete obj.cargo;
        delete obj.idgrado;
      },
      parseLabel2(option) {
        if (option == null) return '';
        var seg = option.seg_apellido;
        if (seg == null) seg = '';
        return option.nombres + ' ' + option.pri_apellido + ' ' + seg + ' -- Doc: ' + option.num_doc;
      },
      enviarDAtos(obj) {
        var vue = this;
        // QUITADO, AL PARECER NO SirVE Y TIRA EL BACK EN LOCAL DE EDGAR :)
        // obj.notification = vue.notification; 
        let input = window.stringifyObject(obj);
        var sql = gql`mutation{ createPersona(input:${input}){ok,persona{id,num_doc,nombres,pri_apellido,seg_apellido},errors{message}} }`;
        vue.msg = '';
        // window.console.log('CREANDO ESTUDIANTE: ', sql);
        // window.console.log(input);
        window.console.log('>>>',obj,this.newProvincia,this.newCiudadExt);

        this.$apollo
          .mutate({
            mutation: sql,
          })
          .then((data) => {
            if (data.data.createPersona.ok) {
              vue.$refs.alertar.success();
              window.sessionStorage.setItem('xnewEstudiante', null);
              this.activo = true;
              var us = data.data.createPersona.persona;
              vue.inscripcion.idestudiante = { id: us.id, nombre: vue.parseLabel2(us) };
              vue.msg = '';
              vue.telefonows = '';
              vue.$emit('onnewregistro', us.num_doc, us);

              /*let user = this.$store.state.DATA_USER.id;
              let sede = this.$store.state.CARGO.idsede;
              let txt = `Nueva persona: U${user} - S${sede} > ${input}`;

              fetch(
                'https://api.telegram.org/bot1780932396:AAER4sTDMHBpWkiS66wVZVN9TenE7wUZ9Mg/sendMessage?chat_id=293911327&text=' +
                  txt,
              )
                .then((response) => response.json())
                .then((data) => {
                  window.console.log(data);
                });*/

              setTimeout(function() {
                window.$('#collapseExample').collapse('hide');
                window.$('#collapseExample').scrollTop({ top: 0, left: 0, behavior: 'smooth' });
              }, 1000);
            } else {
              var errores = JSON.stringify(data.data.createPersona.errors);
              var obj = JSON.parse(errores);
              var vals = '';
              obj.forEach(function(k) {
                vals += Object.values(k) + '-\n\t';
              });
              vue.msg = '';
              vue.activo = true;
              vue.$refs.alertar.invalido(vals);
            }

            window.console.log(data);
          })
          .catch((error) => {
            vue.$refs.alertar.invalido();
            this.activo = true;
            window.console.error(JSON.stringify(error));
            this.$notify(parseJsonError(error));
          });
      },
    },
    mounted() {
      this.apiwhatsapp = process.env.VUE_APP_API_WHATSAPP;
      this.main();
    },
  };
</script>
